<div class="modal-header">
  <h2 mat-dialog-title>Remove User Group</h2>
  <button type="button" class="close-button" mat-dialog-close aria-label="Close modal"><span class="ion-android-close" area-hidden="true"></span></button>
</div>
<mat-dialog-content>
  <p>Are you sure you want to remove this group from the team?</p>
</mat-dialog-content>
<mat-dialog-actions>
  <button type="button" class="button secondary" (click)="cancel()">Cancel</button>
  <button type="button" class="button" (click)="removeMember()">Remove Group</button>
</mat-dialog-actions>
